export const progressIndicator = () => {
    const progressIndicator = document.querySelector('.progress-indicator');
    const progressIndicatorLine = document.querySelector('.progress-indicator__line');

    const moveBar = () => {
        let windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = scrolled = (windowScroll / height) * 100;

        progressIndicatorLine.style.width = scrolled + '%';
    };

    if (progressIndicator) {
        window.onload = () => moveBar();
        window.onscroll = () => moveBar();
    }
};
